// Material
import { createTheme, ThemeProvider as MuiThemProvider } from '@mui/material/styles';

// Local
import palette from './palette';
import overrides from './overrides';
import transitions from './transitions';
import typography from './typography';

export const Theme = createTheme({
  palette,
  components: overrides,
  spacing: 8,
  transitions,
  typography,
});

export const ThemeProvider = ({ children }) => <MuiThemProvider theme={Theme}>{children}</MuiThemProvider>;
